/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../cart-service-apis/restClient';

const RESOURCE_ROOT_CARTSERVICE = '/checkout';
const RESOURCE_VERSION_CARTSERVICE = '/v2';
const RESOURCE_PAGE_CARTSERVICE = '/cart';
const RESOURCE_PAGE_ACTION = '/subcart/tip';

/**
 * addToCart
 * url - /checkout/{apiVersion}/cart/subcart/tip?brand={brandId}
 *
 * @param {Object} args
 * @param {String} args.env
 * @param {string} args.jwtToken
 * @param {string} args.cartId
 * @param {string} args.tipAmount
 */
const externalCartUpdateDTW = ({
    env, jwtToken, cartId, tipAmount,
}) => {
    const envObj = env || {};

    envObj.rootUri = `${RESOURCE_ROOT_CARTSERVICE}${RESOURCE_VERSION_CARTSERVICE}`;

    const resourcePage = `${RESOURCE_PAGE_CARTSERVICE}/${cartId}${RESOURCE_PAGE_ACTION}`;
    const payload = {
        tipAmount,
    };
    return restClient.putRequest(envObj, resourcePage, jwtToken, payload)
        .then((response) => response);
};

export default externalCartUpdateDTW;
